import React, {useState, useEffect, useRef} from 'react'
import { Button, Col, Row } from 'antd';
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";

dayjs.extend(customParseFormat);

const TimePickerMobile = ({
    showTimePicker, 
    setShowTimePicker, 
    StyledDiv,
    formState,
    setFormState,
    setGeneralValidations
}) => {
    const hourRef = useRef(null);
    const minuteRef = useRef(null);
    const secondRef = useRef(null);
    const ampmRef = useRef(null);

    const hours = Array.from({ length: 12 }, (_, index) => (index + 1).toString());
    const minutes = Array.from({ length: 60 }, (_, index) => index.toString().padStart(2, '0'));
    const seconds = Array.from({ length: 60 }, (_, index) => index.toString().padStart(2, '0'));
    const ampm = ['am', 'pm'];

    const [selectedData, setSelectedData] = useState({
        hour: "",
        minute: "",
        second: "",
        ampm: ""
    });
    
    
    

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            const newTime = getTimeParts(formState.timeObserved)
            setSelectedData(newTime);
            centerSelectedItem(hourRef, newTime.hour);
            centerSelectedItem(minuteRef, newTime.minute);
            centerSelectedItem(secondRef, newTime.second);
            centerSelectedItem(ampmRef, newTime.ampm);
        }

        return () => {  
            mounted = false;
        }
    }, [showTimePicker, formState.timeObserved]);

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            centerSelectedItem(hourRef, selectedData.hour);
            centerSelectedItem(minuteRef, selectedData.minute);
            centerSelectedItem(secondRef, selectedData.second);
            centerSelectedItem(ampmRef, selectedData.ampm);
        }

        return () => {  
            mounted = false;
        }
    }, [selectedData]);

    function getTimeParts(timeString) {
        if(timeString){
            const [hour, minute, lastHalf] = timeString.split(':');
            const [second, ampm] = lastHalf.split(' ');
            return { hour, minute, second, ampm };
        }else{
            return { hour: "", minute: "", second: "", ampm: "" };
        }
    }

    const centerSelectedItem = (ref, selectedIndex) => {
        if (ref.current) {
            const selectedItem = ref.current.querySelector(`[data-index="${selectedIndex}"]`);
            if (selectedItem) {
                const container = ref.current;
                const containerHeight = container.clientHeight;
                const itemHeight = selectedItem.clientHeight;
                const itemOffsetTop = selectedItem.offsetTop;

                const scrollTo = itemOffsetTop - (containerHeight / 2) + (itemHeight / 2);
                container.scrollTop = scrollTo;
            }
        }
    };
    

    const handleSetTime = () => {
        const {hour, minute, second} = selectedData;
        let timeObserved = '';
    
        timeObserved += `${hour.toString()}:${minute.toString().padStart(2, '0')}:${second.toString().padStart(2, '0')} ${selectedData.ampm}`;
    
        setFormState({...formState, timeObserved: timeObserved, defaultTime: dayjs(timeObserved, 'h:mm:ss a')});
        setGeneralValidations(prevState => ({ ...prevState, timeObserved: "" }));
        setShowTimePicker(false);
    }

  return (
    <>
        {showTimePicker && <div className="modal-overlay"
                style={{
                    height: "100dvh",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "end"
                }}
            >
                <Col 
                    xl={{span: 24}}
                    lg={{span: 24}}
                    md={{span: 24}}
                    sm={{span: 24}}
                    xs={{span: 24}} 
                    style={{
                        height: "55dvh",
                    }}

                >
                    <div className="modal"
                        style={{
                            height: "100%"
                        }}
                    >
                        <Row
                            style={{
                                marginBottom: "10px",
                                height: "15%",
                            }}
                        >
                            <Col
                                span={12}
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                }}
                            >
                                <Button
                                    onClick={() => {
                                        handleSetTime()
                                    }}
                                >Select</Button>
                            </Col>

                            <Col
                                span={12}
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                }}
                            >
                                <Button
                                    onClick={() => setShowTimePicker(false)}
                                >Close</Button>
                            </Col>
                        </Row>

                        <Row
                            style={{
                                marginBottom: "10px",
                                height: "10%",
                            }}
                        >
                            <Col
                                span={6}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <StyledDiv
                                    style={{
                                        fontWeight: "600"
                                    }}
                                >HH</StyledDiv>
                            </Col>

                            <Col
                                span={6}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <StyledDiv
                                    style={{
                                        fontWeight: "600"
                                    }}
                                >MM</StyledDiv>
                            </Col>

                            <Col
                                span={6}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <StyledDiv
                                    style={{
                                        fontWeight: "600"
                                    }}
                                >SS</StyledDiv>
                            </Col>

                            <Col
                                span={6}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <StyledDiv
                                    style={{
                                        fontWeight: "600"
                                    }}
                                ></StyledDiv>
                            </Col>
                        </Row>
                        <hr/>

                        <Row
                            style={{
                                height: "60%",
                            }}
                        >
                            <Col
                                span={6}
                                className="scroll-container"
                                ref={hourRef}
                            >
                                {hours.map((hour, index) => {
                                    return(
                                        <Row
                                            key={hour + index}
                                            data-index={hour}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                marginBottom: "20px",
                                                paddingTop: index === 0 ? "75px" : "0px",
                                                paddingBottom: index === hours.length - 1 ? "60px" : "0px",
                                                
                                                
                                            }}
                                        >
                                            <StyledDiv
                                                onClick={() => {
                                                    setSelectedData({...selectedData, hour: hour});
                                                }}
                                                style={{
                                                    fontSize: "16px",
                                                    color: selectedData.hour === hour ? 'rgb(174,32,114)' : 'black',
                                                    cursor: "pointer",
                                                }}
                                            >{hour}</StyledDiv>
                                        </Row>
                                    )
                                })}
                            </Col>

                            <Col
                                span={6}
                                className="scroll-container"
                                ref={minuteRef}
                            >
                                {minutes.map((minute, index) => {
                                    return(
                                        <Row
                                            key={minute + index}
                                            data-index={minute}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                marginBottom: "20px",
                                                paddingTop: index === 0 ? "75px" : "0px",
                                                paddingBottom: index === minutes.length - 1 ? "70px" : "0px",
                                                
                                                
                                            }}
                                        >
                                            <StyledDiv
                                                onClick={() => {
                                                    setSelectedData({...selectedData, minute: minute});
                                                }}
                                                style={{
                                                    fontSize: "16px",
                                                    color: selectedData.minute === minute ? 'rgb(174,32,114)' : 'black',
                                                    cursor: "pointer",
                                                }}
                                            >{minute}</StyledDiv>
                                        </Row>
                                    )
                                })}
                            </Col>

                            <Col
                                span={6}
                                className="scroll-container"
                                ref={secondRef}
                            >
                                {seconds.map((second, index) => {
                                    return(
                                        <Row
                                            key={second + index}
                                            data-index={second}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                marginBottom: "20px",
                                                paddingTop: index === 0 ? "75px" : "0px",
                                                paddingBottom: index === seconds.length - 1 ? "70px" : "0px",
                                                
                                                
                                            }}
                                        >
                                            <StyledDiv
                                                onClick={() => {
                                                    setSelectedData({...selectedData, second: second});
                                                }}
                                                style={{
                                                    fontSize: "16px",
                                                    color: selectedData.second === second ? 'rgb(174,32,114)' : 'black',
                                                    cursor: "pointer",
                                                }}
                                            >{second}</StyledDiv>
                                        </Row>
                                    )
                                })}
                            </Col>

                            <Col
                                span={6}
                                className="scroll-container"
                                ref={ampmRef}
                            >
                                {ampm.map((data, index) => {
                                    return(
                                        <Row
                                            key={data + index}
                                            data-index={data}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                marginBottom: "20px",
                                                paddingTop: index === 0 ? "75px" : "0px",
                                                paddingBottom: index === ampm.length - 1 ? "60px" : "0px",
                                                
                                                
                                            }}
                                        >
                                            <StyledDiv
                                                onClick={() => {
                                                    setSelectedData({...selectedData, ampm: data});
                                                }}
                                                style={{
                                                    fontSize: "16px",
                                                    color: selectedData.ampm === data ? 'rgb(174,32,114)' : 'black',
                                                    cursor: "pointer",
                                                }}
                                            >{data.toUpperCase()}</StyledDiv>
                                        </Row>
                                    )
                                })}
                            </Col>
                        </Row>

                        <Row
                            style={{
                                marginBottom: "10px",
                                height: "15%",
                            }}
                        >
                            
                        </Row>
                        
                    </div> 
                </Col> 
            </div>} 
    </>
  )
}

export default TimePickerMobile
